import React, { createContext, useContext, useState } from 'react';
import ErrorPopup from '../components/ErrorPopup/ErrorPopup';
import PropTypes from 'prop-types';
import WlzPopup from "../views/RentalRequest/sub-components/ClientInformation/WlzPopup";

const DialogContext = createContext(null);

export const DialogProvider = ({ children }) => {
  const [dialog, setDialog] = useState({
    type: null,
    message: ''
  });
  
  const showDialog = (type, message) => {
    setDialog({
      type,
      message
    });
  };

  const hideDialog = () => {
    setDialog({
      type: null,
      message: ''
    });
  };

  const isAdPopupOpen = dialog.type === 'ad-service';

  return (
    <DialogContext.Provider value={{ showDialog, hideDialog, isAdPopupOpen }}>
      {children}
      {/* TODO: Place dialogs here, errors, messages, ad popups, etc. */}
      {isAdPopupOpen && (
        <WlzPopup
          show={showDialog}
          hide={hideDialog}
          title="Denk je aan de aanvraag bij het zorgkantoor."
          content="Om deze aanpassing goed te kunnen verwerken is een aanvraag bij het zorgkantoor noodzakelijk.
                  Graag ontvangen we deze zo spoedig mogelijk."
          label="Ik begrijp het"
        />
      )}
      {dialog.type === 'error' && (
        <ErrorPopup
          message={dialog.message}
          open
        />
      )}
    </DialogContext.Provider>
  );
};

DialogProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useDialog = () => {
  const context = useContext(DialogContext);
  if (!context) throw new Error('useDialog must be used within DialogProvider');
  return context;
};